const SGKWorkerTipi = {
    0: "İş Kazası",
    1: "EVizite",
    2: "Tahakkuk",
    3: "EBorc",
    4: "AUDI-Geçmiş Sene",
    5: "AUDI-Guncel Sene",
    6: "AUDI Veri Okuma",
    7: "Cari Giriş Çıkış",
}

export default SGKWorkerTipi;
